import { confirm } from 'cadenza/alert';
import { LayerProperty } from 'cadenza/map/layer-property';
import { resetSelection } from 'cadenza/map/layer-utils';
import { removeSelectedFeatures } from 'cadenza/api-client/maps-api';

import i18n from './layer-actions.properties';
import { LayerAction } from './layer-action';

export class FeatureRemove extends LayerAction {

  constructor (layer, options) {
    super(layer, Object.assign({
      label: i18n('mapConfig.removeFeatures')
    }, options));
  }

  execute () {
    return confirm(i18n('featureEditor.removeFeaturesMessage', { count: this._layer.get(LayerProperty.SELECTED_FEATURE_IDS).length }))
      .then(confirmed => {
        if (confirmed) {
          // eslint-disable-next-line promise/no-nesting
          return removeSelectedFeatures(this._layer.get(LayerProperty.ID))
            .then(() => resetSelection(this._layer));
        }
      });
  }

  isSupportedSync ({ isEditingLayer }) {
    return !isEditingLayer
    && this._layer.get(LayerProperty.HAS_FEATURES)
    && this._layer.get(LayerProperty.SELECTED_FEATURE_IDS).length > 0
    && this._layer.get(LayerProperty.SUPPORTS_FEATURE_REMOVAL);
  }

  requiresObjectSelection () {
    return true;
  }

}
